import script from "./PlatChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatChannel.vue?vue&type=script&lang=ts&setup=true"

import "./PlatChannel.vue?vue&type=style&index=0&id=2c3ac334&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3ac334"]])

export default __exports__